import React from "react";

export default function Link(props) {
	return(
		<a	className="link"
			href={props.url}
			target="_blank">

			{props.children}
		</a>
	);
}


// WEBPACK FOOTER //
// ./src/js/common/components/Link.js